<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M51.5 18h-7v-7A3.5 3.5 0 0041 7.5H23a3.5 3.5 0 00-3.5 3.5v7h-7A7.5 7.5 0 005 25.5V53a2 2 0 002 2h50a2 2 0 002-2V25.5a7.5 7.5 0 00-7.5-7.5zm-29-7a.5.5 0 01.5-.5h18a.5.5 0 01.5.5v7h-19zm-10 10h39a4.51 4.51 0 014.5 4.5v8H44.5v-2.33a1.5 1.5 0 00-3 0v2.33h-19v-2.33a1.5 1.5 0 00-3 0v2.33H8v-8a4.51 4.51 0 014.5-4.5zM8 52V36.5h11.5v2.67a1.5 1.5 0 003 0V36.5h19v2.67a1.5 1.5 0 003 0V36.5H56V52z"/></svg>